import { getHostname } from '@utils/strings'

export default (url) => {
  if (!url) return null

  const hostname = getHostname(url)

  const website = domains
    .find(([_, domain]) => hostname === domain)

  if (!website) return null

  return website[0]
}

const domains = [
  ['AnandTech', 'www.anandtech.com'],
  ['Ars Technica', 'arstechnica.com'],
  ['CNET', 'www.cnet.com'],
  ['DigitalTrends', 'www.digitaltrends.com'],
  ['Engadget', 'www.engadget.com'],
  ['GamesRadar', 'www.gamesradar.com'],
  ['Input', 'www.inverse.com'],
  ['IGN', 'www.ign.com'],
  ['LaptopMedia', 'laptopmedia.com'],
  ['LaptopNinja', 'www.laptopninja.com'],
  ['LaptopUnderBudget', 'www.laptopunderbudget.com'],
  ['Laptopmag', 'www.laptopmag.com'],
  ['Notebookcheck', 'www.notebookcheck.net'],
  ['PCMag', 'www.pcmag.com'],
  ['PCWorld', 'www.pcworld.com'],
  ['RTINGS', 'www.rtings.com'],
  ['Stuff', 'www.stuff.tv'],
  ['Tech Advisor', 'www.techadvisor.com'],
  ['TechSpot', 'www.techspot.com'],
  ['TechRadar', 'www.techradar.com'],
  ['The Verge', 'www.theverge.com'],
  ['Tom\'s Hardware', 'www.tomshardware.com'],
  ['Top New Review', 'topnewreview.com'],
  ['Ultrabookreview', 'www.ultrabookreview.com'],
  ['tom\'s guide', 'www.tomsguide.com'],
]
